export default __webpack_public_path__ + "static/media/connectionButton.8639fed6.svg";